import * as s from "../SignupStyled";
import * as cs from "../../SignCommonStyled";
import PROFILE_ICON from "assets/icons/account_profile.svg";
import { Text } from "components/atoms/text/Text";
import { MdEmail } from "react-icons/md";
import { COLORS } from "styles/colors";
import { IoCheckmarkCircle } from "react-icons/io5";
import {
  SIGNUP_STEP,
  SignupUserInfo,
} from "api/interfaces/authInterface.interface";
import { successMessages } from "utils/AuthUtil";

interface Props {
  userInfo: SignupUserInfo;
  onClickLogin: () => void;
  step: SIGNUP_STEP;
  checkedEmail: string;
  isResend: boolean;
}

export default function Success(props: Props): JSX.Element {
  const { onClickLogin, userInfo, step } = props;

  return (
    <s.SuccessInner>
      {step === SIGNUP_STEP.RESELLER_SUBMISSION_SUCCESS ||
      step === SIGNUP_STEP.TRIAL_SEND_EMAIL ? (
        <div className="email-icon-wrapper">
          <MdEmail size={100} color={COLORS.BUTTONS2} />
          <IoCheckmarkCircle
            size={30}
            color={"#08a732"}
            className="checkmark-icon"
          />
        </div>
      ) : (
        <img src={PROFILE_ICON} width="185" alt="Profile Icon" />
      )}

      {(userInfo.firstName || userInfo.lastName) && (
        <Text fontSize={18} className="user-name">
          {userInfo.firstName + " " + userInfo.lastName}
        </Text>
      )}

      <div className="success-box">
        <div className="title">
          {successMessages.title[step as keyof typeof successMessages.title]}
        </div>
        <div
          className="description"
          style={
            step === SIGNUP_STEP.TRIAL_SUCCESS ||
            step === SIGNUP_STEP.TRIAL_SEND_EMAIL
              ? { textAlign: "left" }
              : {}
          }
        >
          {step === SIGNUP_STEP.TRIAL_SEND_EMAIL && (
            <>
              {props.isResend &&
                "An invitation has already been sent to this email address. "}
              We have sent a verification link to{" "}
              <b className="email">{props.checkedEmail}</b>
              <br />
              <br />
            </>
          )}

          {
            successMessages.description[
              step as keyof typeof successMessages.description
            ]
          }
        </div>
      </div>
      <cs.BigButton
        id="dw_signup_button_login"
        type="button"
        onClick={onClickLogin}
        data-testid="auth-signup-step-button-login-click-login"
      >
        {step === SIGNUP_STEP.RESELLER_SUBMISSION_SUCCESS ||
        step === SIGNUP_STEP.TRIAL_SEND_EMAIL
          ? "OK"
          : "Login"}
      </cs.BigButton>
    </s.SuccessInner>
  );
}
